const STORAGE_KEY = 'weddingTapeDeckTransformV1';

/** @typedef {{ x: number; y: number; scale: number; widthPct: number }} TapeDeckTransform */

export const DEFAULT_TAPE_DECK_TRANSFORM = /** @type {TapeDeckTransform} */ ({
  x: -4,
  y: -49,
  scale: 99,
  widthPct: 68,
});

/** @returns {TapeDeckTransform} */
export function loadTapeDeckTransform() {
  if (typeof localStorage === 'undefined') return { ...DEFAULT_TAPE_DECK_TRANSFORM };
  try {
    const raw = localStorage.getItem(STORAGE_KEY);
    if (!raw) return { ...DEFAULT_TAPE_DECK_TRANSFORM };
    const p = JSON.parse(raw);
    return {
      x: typeof p.x === 'number' && Number.isFinite(p.x) ? p.x : DEFAULT_TAPE_DECK_TRANSFORM.x,
      y: typeof p.y === 'number' && Number.isFinite(p.y) ? p.y : DEFAULT_TAPE_DECK_TRANSFORM.y,
      scale:
        typeof p.scale === 'number' && Number.isFinite(p.scale) && p.scale > 0
          ? p.scale
          : DEFAULT_TAPE_DECK_TRANSFORM.scale,
      widthPct:
        typeof p.widthPct === 'number' && Number.isFinite(p.widthPct) && p.widthPct > 0
          ? p.widthPct
          : DEFAULT_TAPE_DECK_TRANSFORM.widthPct,
    };
  } catch {
    return { ...DEFAULT_TAPE_DECK_TRANSFORM };
  }
}

/** @param {TapeDeckTransform} t */
export function saveTapeDeckTransform(t) {
  if (typeof localStorage === 'undefined') return;
  try {
    localStorage.setItem(STORAGE_KEY, JSON.stringify(t));
  } catch {
    /* ignore */
  }
}
